<template>
    <div :class="{ 'fui-floating': floating, [icon]: true, 'fui-has-fa': !!icon }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: '',
        },
    },
};
</script>
